import { render, staticRenderFns } from "./BillPayableStatsCard.vue?vue&type=template&id=667e4f19"
import script from "./BillPayableStatsCard.vue?vue&type=script&lang=js"
export * from "./BillPayableStatsCard.vue?vue&type=script&lang=js"
import style0 from "./BillPayableStatsCard.vue?vue&type=style&index=0&id=667e4f19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports